import React, { Component } from 'react';

import Container from 'react-bootstrap/Container';

import PARTNER from '../../assets/odyssea.png';

class Footer extends Component {
  render() {
    return (
      <footer className="mt-5 text-center">
        <Container>
          <span className="partnership-with">En partenariat avec</span>
          <div className="mt-2">
            <img className="img-fluid w-50" src={PARTNER} alt="Odyssea" />
          </div>
        </Container>
      </footer>
    );
  }
}

export default Footer;
